define('app/sf/site/title/sf-site-title-filter',["service!sss-site"], function (siteService) {
	sfSiteTitleFilter.$stateful = true;
	return sfSiteTitleFilter;
	function sfSiteTitleFilter(siteTitle) {
		var siteName = siteService.current.displayName;
		if (siteTitle && siteName) {
			return siteService.current.displayName + " - " + siteTitle;
		}
		else if (siteName) {
			return siteName;
		}
		else {
			return siteTitle;
		}
	}
});
